import currency from 'currency.js'

import TextButton from '../../TextButton'

type TPaymentItem = {
  amount: number
  description: string
  vat?: number
}

type Props = {
  cardItems: TPaymentItem[]
  cardTotal: number
  cardVatTotal: number
  isDisabled?: boolean
  onOpenPaymentMethodModal: () => void
  paymentMethodsLength: number
  paymentMethodText: string
}

const formatPence = (amount: number) => {
  return currency(amount).divide(100).format()
}

const CheckoutPaymentSummary = (props: Props) => {
  const {
    cardItems,
    cardTotal,
    cardVatTotal,
    isDisabled,
    onOpenPaymentMethodModal,
    paymentMethodsLength,
    paymentMethodText,
  } = props

  return (
    <div className="rounded-md border border-gray-200 mt-4">
      <div className="border-b border-gray-200 px-4 py-3">
        <h4 className="text-sm font-medium text-black">
          Payment to be taken via debit/credit card
        </h4>
      </div>
      <div className="divide-y divide-gray-200">
        {cardItems.length > 0 ? (
          cardItems.map((item) => (
            <div
              className="flex items-center justify-between px-4 py-3"
              key={item.description}
            >
              <p className="text-sm text-gray-700">{item.description}</p>
              <p className="text-sm text-gray-700">
                GBP {formatPence(item.amount)}
              </p>
            </div>
          ))
        ) : (
          <div className="px-4 py-3">
            <p className="text-sm text-gray-600">No add-ons selected</p>
          </div>
        )}

        {cardTotal > 0 && (
          <div className="px-4 py-3 text-xs font-medium text-gray-600">
            <div className="flex items-start justify-between gap-3 pb-1">
              <p>
                Using {paymentMethodText}{' '}
                {paymentMethodsLength > 1 && (
                  <TextButton
                    size="xs"
                    className="ml-1"
                    onClick={isDisabled ? undefined : onOpenPaymentMethodModal}
                  >
                    Change
                  </TextButton>
                )}
              </p>
              <p>
                Subtotal{' '}
                <span className="inline-block min-w-18.75 text-right">
                  {formatPence(cardTotal - cardVatTotal)}
                </span>
              </p>
            </div>
            <div className="flex justify-end pb-1">
              <p>
                VAT{' '}
                <span className="inline-block min-w-18.75 text-right">
                  {formatPence(cardVatTotal)}
                </span>
              </p>
            </div>
          </div>
        )}

        <div className="flex items-center justify-between px-4 py-3">
          <p className="text-sm font-semibold tracking-tight text-black">
            Total payment to be taken
          </p>
          <p className="text-sm font-semibold tracking-tight text-black">
            {cardTotal > 0 ? `GBP ${formatPence(cardTotal)}` : 'N/A'}
          </p>
        </div>
      </div>
    </div>
  )
}

export type { TPaymentItem }

export default CheckoutPaymentSummary
